import { createContext, useContext, useSyncExternalStore } from 'react';
import { getConfig, subscribeConfig } from './configStore.js';
import type { ConfigState } from './configStore.js';
import type { FeatureFlags } from '../../common/types/featureFlags.js';
import type { ReactNode } from 'react';

// NOTE!
// - DO NOT use the `ConfigContext` outside of this file, except for tests. It is only exported for tests.
// - We have to use a default value because `ConfigProvider` may be placed high in the React tree, above
//   places that render without it (e.g. error boundaries). See AuthProvider.tsx for the same reasoning.
export const ConfigContext = createContext<ConfigState>(getConfig());

export const ConfigProvider = ({ children }: { children?: ReactNode }) => {
  const config = useSyncExternalStore(subscribeConfig, getConfig, getConfig);
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = (): ConfigState => useContext(ConfigContext);

export const useFeatureFlags = (): FeatureFlags => useContext(ConfigContext).featureFlags;
